import { createGlobalStyle } from 'styled-components';
import { rgba } from 'polished';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const Styles = createGlobalStyle`
  .ReactModal__Overlay {
    background-color: transparent;
    transition: background-color 0.3s ease;
  }
  
  .ReactModal__Overlay--after-open {
    background-color: ${rgba(Colors.black, 0.5)};
    overflow-y: auto;
  }

  .ReactModal__Overlay--before-close {
    background-color: transparent;
  }

  .ReactModal__Content {
    transition-property: opacity, transform;
    transition-duration: 0.3s;
    transition-timing-function: ease;
    opacity: 0;
    transform: translate(-50%, -15%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
  }

  .ReactModal__Content--after-open {
    transform: translate(-50%, 0%);
    opacity: 1;
  }

  .ReactModal__Content--before-close {
    opacity: 0;
    transform: translate(-50%, -15%);
  }
  
  .slide-down-opacity-enter {
    opacity: 0;
    transform: translateY(-100%);
  }
  
  .slide-down-opacity-enter-active {
    transform: translateY(0);
    opacity: 1;
    transition-property: transform, opacity;
    transition-duration:  0.3s;
    transition-timing-function: ease;
  }
  .slide-down-opacity-exit {
    transform: translateY(0);
    opacity: 1;
  }
  
  .slide-down-opacity-exit-active {
    transform: translateY(-100%);
    opacity: 0;
    transition-property: transform, opacity;
    transition-duration:  0.3s;
    transition-timing-function: ease;
  }
  
  .opacity-enter {
    opacity: 0;
  }
  
  .opacity-enter-active {
    opacity: 1;
    transition: opacity 0.3s ease;
  }
  .opacity-exit {
    opacity: 1;
  }
  
  .opacity-exit-active {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
`;
